module.exports = __webpack_public_path__ + "static/taxes_chart-2305f0ef1d3139cefc1ff28d6f30fe37.png";